var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['flex flex-row items-center justify-center',
  'rounded-full bg-white bg-opacity-20',
  'lg:w-28 md:w-20 w-24',
  'lg:h-28 md:h-20 h-24',
  'lg:p-0 md:p-4 p-5'
  ]},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }